/** 计费页面的纯逻辑（可单测） */

export interface UsageRow {
  key: string;
  costMicroUsd: number;
  amount: number;
  unit: string;
}

export type RangeDays = 7 | 30 | 90;

/** 查询区间：今天（UTC）往前 days 天，to = 明天 0 点（UTC，半开区间） */
export function rangeOf(days: RangeDays, now = Date.now()): { from: string; to: string; fromDay: string; toDay: string } {
  const d = new Date(now);
  const tomorrow = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() + 1);
  const from = tomorrow - days * 86_400_000;
  return { from: new Date(from).toISOString(), to: new Date(tomorrow).toISOString(), fromDay: new Date(from).toISOString().slice(0, 10), toDay: new Date(tomorrow - 86_400_000).toISOString().slice(0, 10) };
}

/** 按天分组时补齐没有用量的日期（值为 0），保证横轴连续 */
export function fillDays(rows: UsageRow[], fromDay: string, toDay: string): UsageRow[] {
  const byKey = new Map(rows.map((r) => [r.key, r]));
  const out: UsageRow[] = [];
  const unit = rows[0]?.unit ?? "";
  for (let t = Date.parse(`${fromDay}T00:00:00Z`); t <= Date.parse(`${toDay}T00:00:00Z`); t += 86_400_000) {
    const key = new Date(t).toISOString().slice(0, 10);
    out.push(byKey.get(key) ?? { key, costMicroUsd: 0, amount: 0, unit });
  }
  return out;
}

/** 坐标轴上限：取 1 / 2 / 2.5 / 5 × 10^n 中不小于 max 的最小值 */
export function niceMax(max: number): number {
  if (!(max > 0)) return 1;
  const p = 10 ** Math.floor(Math.log10(max));
  for (const m of [1, 2, 2.5, 5, 10]) if (m * p >= max) return m * p;
  return 10 * p;
}

/** 美元（主单位）字符串 → 币种最小单位（美分 / 分）；非法返回 null */
export function toMinorUnits(v: string): number | null {
  const s = v.trim();
  if (!/^\d+(\.\d{1,2})?$/.test(s)) return null;
  const n = Math.round(Number(s) * 100);
  return n > 0 ? n : null;
}

/** 可选金额（美元）→ micro-USD；空 = null；非法 = undefined */
export function optionalUsd(v: string): number | null | undefined {
  const s = v.trim();
  if (!s) return null;
  const n = Number(s);
  return Number.isFinite(n) && n >= 0 ? Math.round(n * 1_000_000) : undefined;
}

export const microToUsdInput = (m: number | null) => (m === null ? "" : String(m / 1_000_000));

/** 充值后等待到账：余额超过充值前即视为到账 */
export function topupArrived(before: number, now: number | undefined): boolean {
  return now !== undefined && now > before;
}
